<form [formGroup]="formGroup" novalidate (ngSubmit)="onSubmit()">
    <div id="serviceDetailsContainer" class="container absolute top-20 right-0 z-10 hiddenDetails h-[calc(100vh-80px)]"
        [ngClass]="{
            'openDetails': (serviceInfoDetail || newService),
            'edit': (serviceInfoDetail || newService) && edit,
            'expanded': expanded
        }">
        <section class="topbar h-14 mt-4 flex items-center">
            <h1 class="ml-8 text-xl font-semibold max-w-[25%] truncate">{{ literalService.get('services.serviceTitle', true) }}</h1>
            @if (serviceInfoDetail && serviceInfoDetail.id) {
                <section id="actions" class="flex ml-auto mr-8">
                    <div class="flex items-center justify-center content-image mr-2">
                        <img [src]="images.services.edit" (click)="this.editEvent.emit()" [tooltip]="literalService.get('services.tooltips.edit', true)" alt="edit" class="h-6 w-6 ml-4 mr-4 cursor-pointer">
                    </div>
                    @if (userRole === 'SUPERADMIN') {
                        <div class="flex items-center justify-center content-image mr-2">
                            <img [src]="images.services.delete" (click)="this.deleteEventEmitter.emit(serviceInfoDetail.id)" [tooltip]="literalService.get('services.tooltips.delete', true)" alt="delete" class="h-6 w-6 ml-4 mr-4 cursor-pointer">
                        </div>
                    }
                    <div class="flex items-center justify-center cursor-pointer mr-2" (click)="close()">
                        <img [src]="images.close" alt="closeDetails" class="h-6 w-6"/>
                    </div>
                </section>
            } @else {
                <section id="actions" class="flex ml-auto mr-8">
                    <div class="flex items-center justify-center cursor-pointer mr-2" (click)="close()">
                        <img [src]="images.close" alt="closeDetails" class="h-6 w-6"/>
                    </div>
                </section>
            }
        </section>
        <section class="h-14 mt-8 ml-8 items-center">
            @if (loaded) {
                <div class="flex" [ngClass]="{'gap-3': !edit && !newService}">
                    <div class="flex flex-col flex-1">
                        @if (!edit && !newService) {
                            @for (element of serviceForm; track $index) {
                                @if (!element.expanded) {
                                    <article [ngClass]="{'hidden': element.hidden}">
                                        <app-detail [data]="element" [value]="element.value" />
                                    </article>
                                }
                            }
                        } @else if (edit || newService) {
                            @for (element of serviceForm; track $index) {
                                @if (!element.expanded) {
                                    <div class="mr-10 mb-2.5" [ngClass]="{'hidden': element.edit.hidden, 'mb-7': currentStep === 1 && newService}">
                                        <app-input  [data]="element"
                                                    [edit]="true"
                                                    [translateValue]="element.edit?.translateValue"
                                                    [formGroup]="formGroup"
                                                    (setEventEmitter)="changeData($event, element)"
                                                    (changeEventEmitter)="changeData($event, element)"
                                                    (inputEventEmitter)="liveChangeData($event, element)" />
                                    </div>
                                }
                            }
                        }
                    </div>
                    @if (expanded) {
                        <div class="flex flex-col flex-1">
                            @if (!edit && !newService) {
                                @for (element of serviceForm; track $index) {
                                    @if (element.expanded) {
                                        <article [ngClass]="{'hidden': element.hidden}">
                                            <app-detail [data]="element" [value]="element.value" />
                                        </article>
                                    }
                                }
                            } @else if (edit || newService) {
                                @for (element of serviceForm; track $index) {
                                    @if (element.expanded) {
                                        <div class="mr-10 mb-2.5" [ngClass]="{'hidden': element.edit.hidden}">
                                            <app-input  [data]="element"
                                                        [edit]="true"
                                                        [translateValue]="element.edit?.translateValue"
                                                        [formGroup]="formGroup"
                                                        (setEventEmitter)="changeData($event, element)"
                                                        (changeEventEmitter)="changeData($event, element)"
                                                        (inputEventEmitter)="liveChangeData($event, element)" />
                                        </div>
                                    }
                                }
                            }
                        </div>
                    }
                </div>
            }
            @if (edit || !newService || currentStep === 4) {
                <section class="flex items-center absolute right-2 top-24 bottom-0">
                    <img alt="arrowToExpand" [src]="images.arrowLeft" class="h-5 w-5 cursor-pointer expand"
                         [ngClass]="{'actionRotateArrowOpen': !expanded, 'actionRotateArrowClose': expanded}" (click)="onExpand()" />
                </section>
            }
            <div class="flex absolute bottom-8 right-11">
                @if (serviceWizardService.active) {
                    <app-wizard-step-buttons />
                } @else if (edit) {
                    <div class="flex">
                        <input type="submit" class="primary text-white gap-4 border-2 font-semibold h-10 w-30 uppercase mr-2.5 cursor-pointer" [disabled]="formGroup.invalid" [value]="literalService.get('save', true)" />
                        <input type="button" class="secondary gap-4 border-2 font-semibold h-10 w-30 uppercase cursor-pointer" [value]="literalService.get('cancel', true)" (click)="close()" />
                    </div>
                }
            </div>
        </section>
    </div>
</form>
